import React, { useEffect, useState } from "react"
import styled from "styled-components"
import axios from "axios"


import InvestorsNavbar from "../../components/investors-navbar"
import { H1, Sectionheader, PageContainer } from "../../components/common"
import ClipLoader from "react-spinners/ClipLoader"
import serviceURL from "../../utils/service-url"



import articleIcon from "../../assets/images/article.svg"
import podcastIcon from "../../assets/images/podcast.svg"

const TableContainer = styled.div`
  width: 810px;
  margin-top: 80px;

  &:last-child {
    margin-bottom: 80px;
  }

  @media screen and (max-width: 980px) {
    width: 624px;
  }

  @media screen and (max-width: 640px) {
    width: 333px;
  }
`

const Table = styled.table`
  border-spacing: 0px;
  border-collapse: collapse;
  width: 100%;

  & td, & th { overflow-wrap: anywhere; }

  td {
    padding: 26px 20px;
    border: 1px solid #afafaf;
    border-left: none;
    border-right: none;
    vertical-align: middle;

    &:first-child {
      width: 100%;
    }
  }
`

const Title = styled.a`
  font-size: 20px;
  line-height: 28px;
  font-weight: 700;
  margin-bottom: 10px;
  display: block;
  cursor: pointer;
`

const Meta = styled.p`
  font-size: 18px;

  span {
    margin: 0 8px;
  }

  @media screen and (max-width: 640px) {
    font-size: 12px;
  }
`

const Button = styled.a`
  outline: none;
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: block;
`

const ArticleButton = styled(Button)`
  background: url(${articleIcon}) no-repeat center;
`

const PodcastButton = styled(Button)`
  background: url(${podcastIcon}) no-repeat center;
`
const Loader = styled.div`
  margin-top: 20px;
`

export default function MentionsPage({ pageContext, path }) {

  const { mentions } = pageContext
  const [apimentions, setApimentions] = useState([])
  const [loading, setLoading] = useState(true)
  const maxCheck = 6

  useEffect(() => {

    const fetchNews = async () => {
      let mentionsUrl = "https://api.client.notified.com/api/rss/view/8714?key=773e03b0dc4d4707b5f5cd2c84ea5755"
      if (path.includes("swedish")) {
        mentionsUrl = "https://api.client.notified.com/api/rss/view/8715?key=01b0e8757cca4680a3341eeb1622c86b"
      }

      axios.get(`${serviceURL().api}/notify?link=${mentionsUrl}`).then(({ data }) => {

        const mentionsAPI = data.rss.channel.item.slice(0, maxCheck)
        const firstSixprebuitMentions = mentions.slice(0, maxCheck)

        const diffMentions = mentionsAPI.filter((mention) => !firstSixprebuitMentions.some((s) => s.link._text === mention.link._text)
        )
        setApimentions(diffMentions)
        setLoading(false)

      });

    }

    fetchNews()
  }, [])

  return (
    <PageContainer>
      <InvestorsNavbar
        links={[
          {
            to: "/newsroom/",
            text: "Newsroom",
            flag: " 🌎"
          },
          {
            to: "/newsroom/swedish/",
            text: "Newsroom",
            flag: " 🇸🇪"
          },
          {
            to: "/newsroom/mentions/",
            text: "Mentions",
            flag: " 🌎"
          },
          {
            to: "/newsroom/mentions/swedish/",
            text: "Mentions",
            flag: " 🇸🇪"
          },
        ]}
        showOnMobile
      />

      <Sectionheader>
        <H1>Mentions</H1>
      </Sectionheader>
      <Loader><ClipLoader loading={loading} /> </Loader>
      <TableContainer>
        <Table>
          <tbody>
            {apimentions.concat(mentions).map(({ category, title, pubDate, link, source }) => (
              <tr key={title}>
                <td>
                  <Title href={link._text} target="__blank">
                    {title._text}
                  </Title>
                  <Meta>
                    {source._text}
                    <span>|</span>
                    {new Date(pubDate._text).toISOString().split('T')[0]}
                  </Meta>
                </td>
                <td>
                  {category._text === "Articles" ? (
                    <ArticleButton href={link._text} target="__blank" />
                  ) : (
                    <PodcastButton href={link._text} target="__blank" />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </PageContainer>
  )
}

